import React from "react";
import PropTypes from "prop-types";

import RSRow from "reactstrap/lib/Row";
import { gatherClasses } from "../../lib/utils";

const Row = props => {
  const { dataTestId, form, children } = props;
  return (
    <RSRow
      data-testid={dataTestId}
      className={gatherClasses(props)}
      noGutters={false}
      form={form}
    >
      {children}
    </RSRow>
  );
};

Row.propTypes = {
  form: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dataTestId: PropTypes.string
};

Row.defaultProps = {
  form: false,
  dataTestId: "orion-row"
};

Row.displayName = "OrionRow";

export default Row;
